import { Component, OnInit, Input, TemplateRef, ViewChild, EventEmitter, Output, OnDestroy } from '@angular/core';
import { RootScopeService } from '../../../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../../../core/rootscope-declare';
import { StaffService } from '../../../services/staff.service';
import { FacilityService } from '../../../../core/services/facility.service';
import { FacilityObject } from 'src/app/core/services/facility.model';
import { HaloToastService } from 'src/app/core/halo-toast/halo-toast.service';
import { HaloLoaderService } from '../../../../core/halo-loader/halo-loader.service';
import { IStaffResponse, IStaffObject } from '../../../services/staff.model';
import { CommonUtil } from 'src/app/core/Utils/common-util';
import { HaloModalService, HaloModalSize } from 'src/app/core/halo-modal/halo-modal';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { HaloTipsService } from 'src/app/core/halo-tips/halo-tips.service';
import { AmplitudeAnalyticsService } from 'src/app/core/services/amplitude-analytics.service';

@Component({
  selector: 'app-staff-list',
  templateUrl: './staff-list.component.html',
  styleUrls: ['./staff-list.component.scss'],
})
export class StaffListComponent implements OnInit, OnDestroy {
  rootScopeData: RootScopeDeclare;
  currentFacility: FacilityObject;
  staffList: IStaffObject[];
  selectedStaffEmail: String;
  isCurrentUserAdmin: boolean = false;
  _isMobile: boolean = true;
  name: string;

  private _facilityOnChange: Subscription;
  @ViewChild('modalConfirmResendInviteFooter') modalConfirmResendInviteFooter: TemplateRef<any>;
  @Output() userPermission = new EventEmitter<boolean>();

  constructor(
    private _rootScopeService: RootScopeService,
    private _staffService: StaffService,
    private _toast: HaloToastService,
    private _loader: HaloLoaderService,
    private _router: Router,
    private _facilityService: FacilityService,
    private _util: CommonUtil,
    private _modal: HaloModalService,
    private _tips: HaloTipsService,
    private commonUtil: CommonUtil,
    private _amplitudeAnalytics: AmplitudeAnalyticsService
  ) {}

  getRootScopeData(): void {
    this._rootScopeService.getRootScope().subscribe((rootScopeData) => (this.rootScopeData = rootScopeData));
  }

  ngOnInit(): void {
    this.getRootScopeData();
    this.currentFacility = this._facilityService.selectedFacility();
    this._facilityOnChange = this._facilityService.selectedFacilitySource.subscribe((res) => {
      if(this.currentFacility.facilityId != res.facilityId) {
        this.currentFacility = res;
        //TODO: need to remove the below call to get list if the backend api returns proper error code response for existing email
        this.getManagerList();
        this.commonUtil.scrollTop();
      }
    });
    //TODO: need to remove the below call to get list if the backend api returns proper error code response for existing email
    this.getManagerList();
    this.commonUtil.scrollTop();
  }

  ngOnDestroy(): void {
    this._tips.onDismissed();
    this._facilityOnChange?.unsubscribe();
  }

  @Input() set isMobile(val: boolean) {
    this._isMobile = val;
  }

  @Input() facilityId: string;

  get isMobile(): boolean {
    return this._isMobile;
  }

  getManagerList(): void {
    if (this.currentFacility.facilityId) {
      let permission = this.currentFacility.summary.userRights.facilityStaff === 'F';
      this.userPermission.emit(permission);
      this._loader.startProcess();
      this._staffService.getList(this.currentFacility.facilityId).subscribe(
        (data: IStaffResponse) => {
          this.staffList = data.manager;
          this.staffList.find(
            (user) =>
              (this.isCurrentUserAdmin =
                user.userId === this.rootScopeData.currentUser.userId.toString() && user.isAdmin === 'true')
          ); 
          this._loader.endProcess();
          this.showHaloTips();
        },
        (error) => {
          console.error('API failed.');
          this._loader.endProcess();
        }
      );
    }
  }

  editStaff(staff: IStaffObject): void {
    this._router.navigate(['facility/staff', 'edit', staff.userId]);
  }

  viewStaff(staff: IStaffObject): void {
    this._router.navigate(['facility/staff', 'view', staff.userId]);
  }

  resendInvite(staffEmail: String): void {
    this.selectedStaffEmail = staffEmail;
    this._modal.add({
      dismissible: true,
      titleUppercase: true,
      title: this._util.translateText('RESEND.INVITE'),
      modalSize: HaloModalSize.Medium,
      icon: 'icon-l-warning',
      iconClass: 'warning',
      message: this._util.translateText('RESEND.WELCOME.EMAIL.MSG'),
      footerTemplate: this.modalConfirmResendInviteFooter,
    });
  }

  dismissModal() {
    this._modal.close();
  }

  resendInvitation() {
    this._loader.startProcess();
    let payload = {
      facilityId: this.currentFacility.facilityId,
      email: this.selectedStaffEmail,
    };
    this._amplitudeAnalytics.logEvent({elementName: 'Resend Invitation', action: 'Submit'});
    this._staffService.resendInvite(payload).subscribe(
      (res) => {
        this.dismissModal();
        this._loader.endProcess();
        this._toast.creatToast(this._util.translateText('RESEND.WELCOME.EMAIL.SUCCESS.MSG'));
      },
      (err) => {
        this._loader.endProcess();
      }
    );
  }

  showHaloTips() {
    if(this.rootScopeData.showNewPermissionTooltip && this.currentFacility.summary.facilityRights.lfodEnabledEquipment === 'true'){
      this._tips.add([
        { 
          flag: 'showNewPermissionTooltip', 
          key: 'new-permission', 
          message: 'Added new permission and it is set as “Edit” for all staff, review your staff permission by clicking “Edit” button here.',
          pointerPosition: 'bottom'
        },
      ]);
    }
  }
}
